import { getApv } from '../../apis';
import { pushRouter, routes } from '../../router';
import { setDisableBackControl } from '../../utils/back-control';

const CardRegiCallback = {
  render: async () => {
    return ``;
  },
  afterRender: async () => {
    // PIN 등록여부
    let existPin = true;
    try {
      await getApv('common/pinRegCheck');
    } catch (e) {
      existPin = false;
    } finally {
      // PIN 등록 상태 -> 카드등록완료 이동
      if (existPin) {
        pushRouter(null, null, routes.cardRegiComplete.hashPath);
      }
      // PIN 미등록 -> PIN 등록 -> 카드등록완료
      else {
        pushRouter(
          {
            mode: 'PIN_STEP_1',
            nextHash: routes.cardRegiComplete.hashPath,
          },
          null,
          routes.enterPwd.hashPath,
          () => {
            setDisableBackControl();
          }
        );
      }
    }
  },
};
export default CardRegiCallback;
